interface Response<T> {
    metadata: Metadata
    content: T
}

interface Metadata {
    status: Status
}

enum Status {
    SUCCESS = `SUCCESS`,
    CREATED = `CREATED`,
    BAD_REQUEST = `BAD_REQUEST`,
    RECORD_NOT_FOUND = `RECORD_NOT_FOUND`,
    BUSINESS_ERROR = `BUSINESS_ERROR`,
    SYS_ERROR = `SYS_ERROR`,
    UNAUTHENTICATED = `UNAUTHENTICATED`,
    CONFLICT = `CONFLICT`
}

export type { Response, Metadata }
export { Status }
